import { createSelector, createFeatureSelector } from '@ngrx/store';
import { getSelectedFeaturesIdsAsNumber } from 'src/app/geo/store/selectors/feature.selectors';

import {
  getCropFields,
  selectArableSession,
} from '../registration/store/selectors/crop-field.selectors';
import { ReportSortOption } from '../reports/models';
import { AppState, CropFieldType } from '../shared/models';

export const appSelector = createFeatureSelector<AppState>('app');

export const getCropFieldType = createSelector(selectArableSession, (arable) =>
  arable?.cropFieldType ? arable.cropFieldType : CropFieldType.Advice,
);

export const selectUserSession = createFeatureSelector<{ user?: { customerId?: number } }>(
  'session',
);

export const selectSessionCustomerId = createSelector(
  selectUserSession,
  (session) => session?.user?.customerId,
);

export const getDefaultCropYear = createSelector(appSelector, (store) => store.defaultCropYear);

export const getCropYear = createSelector(
  selectArableSession,
  getDefaultCropYear,
  (arable, defaultCropYear) => (arable?.cropYear ? arable.cropYear : defaultCropYear),
);

export const getAvailableCropYears = createSelector(
  appSelector,
  (store) => store.availableCropYears || [],
);

export const getCropYears = createSelector(appSelector, (store) => store.cropYears || []);

export const getUnselectedFeaturesIdsAsNumber = createSelector(
  getSelectedFeaturesIdsAsNumber,
  getCropFields,
  (cropFieldIds, cropFields) =>
    cropFields
      .filter((cropField) => cropFieldIds.indexOf(cropField.id) === -1)
      .map((cropField) => cropField.id),
);

export const hasAllCropFieldsSelected = createSelector(
  getSelectedFeaturesIdsAsNumber,
  getCropFields,
  (cropFieldIds, cropFields) => cropFieldIds.length === cropFields.length && cropFields.length > 0,
);
export const hasSearch = createSelector(appSelector, (state: AppState) =>
  state?.search ? true : false,
);

export const getReportSort = createSelector(
  appSelector,
  (store) => store.reportSort ?? { option: ReportSortOption.sortCropFieldName, descending: false },
);

export const selectCustomerProgress = createSelector(
  appSelector,
  (store) => store.customerProgress,
);

export const selectAvailableTgaCrops = createSelector(
  appSelector,
  (store) => store.availableTgaCrops,
);
